import React from "react";
import { AdapterDayjs } from "@mui/x-date-pickers/AdapterDayjs";
import { LocalizationProvider } from "@mui/x-date-pickers/LocalizationProvider";
import { DatePicker } from "@mui/x-date-pickers/DatePicker";
import { Box, TextField, Typography } from "@mui/material";
import dayjs from "dayjs";

export default function MUIDatePicker({
  label,
  disable,
  name,
  state,
  value,
  required,
  inputRef,
  onChange,
  minDate,
  maxDate,
}) {
  const RequiredLabel = ({ label }) => (
    <span>
      {label}{" "}
      <span style={{ color: "red", fontSize: "14px", fontWeight: "bold" }}>
        *
      </span>
    </span>
  );

  return (
    <Box sx={{ display: "flex", flexDirection: "column" }}>
      <LocalizationProvider dateAdapter={AdapterDayjs}>
        <DatePicker
          error={state?.errorStatus[name] === true}
          format="DD/MM/YYYY"
          size="small"
          views={["year", "month", "day"]} // Ensures it cycles properly
          disabled={disable}
          label={required ? <RequiredLabel label={label} /> : label}
          inputRef={inputRef}
          value={value || null}
          minDate={minDate ? dayjs(minDate) : null}
          maxDate={maxDate ? dayjs(maxDate) : null}
          sx={{
            "& .MuiFormLabel-root": {
              top: `${value ? "0px" : "-9px"}`,
            },
            ".MuiInputBase-input": {
              padding: "8.5px 14px",
            },

            // '& .MuiInputBase-input': {
            //     height: "8px"
            // },
            color: "black",
            width:
              name === "validFrom" || name === "validTo" ? "220px" : "100%",
          }}
          onChange={onChange}
        />
      </LocalizationProvider>
      <Typography
        sx={{
          marginTop: "2px",
          marginLeft: "10px",
          marginBottom: "0px",
          fontSize: "11px",
          color: "danger.main",
        }}
      >
        {state?.errorFields[name] === "Date required"
          ? ""
          : state?.errorFields[name]}
      </Typography>
    </Box>
  );
}
